import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { CreditCalcInfo, SaleItem } from '../../model/SaleItem';

@Component({
  selector: 'app-credits-calculator',
  templateUrl: './credits-calculator.component.html',
  styleUrls: ['./credits-calculator.component.css']
})
export class CreditsCalculatorComponent implements OnInit {

  @Output() CloseDlg: EventEmitter<SaleItem> = new EventEmitter<SaleItem>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;

  creditCalcInfo:CreditCalcInfo=new CreditCalcInfo();
  saleItem: SaleItem;
  lock = true;
  
  OkButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this)
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this),
  };  

  constructor() {   
  }

  ngOnInit(): void {
  }

  public show(editorData:CreditCalcInfo, saleItem:SaleItem) {  
      this.lock = true;    
      this.creditCalcInfo=editorData;
      this.saleItem = saleItem;
      this.popup.visible = true;
      setTimeout(() => {this.lock = false}, 500);
  }

  btnOk(e) {    
    this.saleItem.Price=this.creditCalcInfo.ExtraCost;
    this.CloseDlg.emit(this.saleItem);
    this.popup.visible = false;
  }

  btnCancel(e) {
    this.CloseDlg.emit(null);
    this.popup.visible = false;
  }

  onPriceChanged(e) {
    if (!this.lock){
      this.saleItem.StaffUpdatedPrice = true;
      this.saleItem.Discount = 0;
    }
  }
}
